import _ from 'lodash';
import { InjectableClass } from '@fino/lib-injection';
import { waitForTransferringStateName } from '../../../../components/ticket/states/waitForTransferring/waitForTransferring.state';

const DOCUMENTS_RESENDEABLE_ON_WAIT_FOR_TRANSFERRING = [
  'signedWarrant',
  'reminder',
  'secondReminder',
];

export class DocumentController extends InjectableClass {
  constructor(controllerService, ticketService, TicketRoutesReceiving) {
    'ngInject';
    super({
      controllerService,
      ticketService,
      TicketRoutesReceiving,
    });
  }

  $onInit() {
    const waitForTransferring = _.find(this.TicketRoutesReceiving, {
      route: waitForTransferringStateName,
    });
    this.isWaitForTransferringState = _.includes(
      waitForTransferring.states,
      this.ticket.status,
    );

    this.showResendButton = this.document.faxResenable;

    // only show "Ermächtigung erneut senden" & "Mahnung erneut senden" when being on wait_for_transferring state
    if (
      _.includes(
        DOCUMENTS_RESENDEABLE_ON_WAIT_FOR_TRANSFERRING,
        this.document.description,
      ) &&
      !this.isWaitForTransferringState
    ) {
      this.showResendButton = false;
    }
  }
}
